import React, { useState, useEffect } from 'react';
import { useRef } from 'react';

import emailjs from 'emailjs-com';
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';


import '../../../styles/contatti.css';
import './style.css';

import Preventivo from './componentiCustom/preventivo/index';
import InfoIniziali from './componentiCustom/infoIniziali/index';
import CopiaAtto from './componentiCustom/copiaAtto/index';
import Consulenza from './componentiCustom/consulenza/index';
import Videoconferenza from './componentiCustom/videoconferenza/index';
import Informazioni from './componentiCustom/informazioni/index';

import InformativaPrivacy from '../../privacyPolicy/index';

export default function ContactUs({ FormTitle }) {
	const ref = useRef(null);

	const [from_name, setFrom_name] = useState(false);
	const [from_surname, setFrom_surname] = useState(false);
	const [from_mail, setFrom_mail] = useState(false);
	const [phone, setPhone] = useState(false);
	const [subject, setSubject] = useState(FormTitle);
	const [message, setMessage] = useState(false);

	const [indirizzo, setIndirizzo] = useState(false);
	const [città, setCittà] = useState(false);

	const [urlPage, setUrlPage] = useState(window.location.pathname)
	const [urlHref, setUrlHref] = useState(window.location.href)

	const [tipoAtto, setTipoAtto] = useState('Acquisto immobiliare')

	const [Prezzodiacquisto, setPrezzodiacquisto] = useState(false)
	const [AgevolazioniPrimaCasa, setAgevolazioniPrimaCasa] = useState('Scegliere')
	const [RichiestaMutuo, setRichiestaMutuo] = useState('Scegliere')
	const [InfoAggiuntive, setInfoAggiuntive] = useState(false)
	const [Venditore, setVenditore] = useState('Scegliere')
	const [RenditaCatastale, setRenditaCatastale] = useState(false)


	const [TipoSocietà, setTipoSocietà] = useState('Scegliere')
	const [CapitaleSociale, setCapitaleSociale] = useState('Scegliere')
	const [TipoAttoSocieta, setTipoAttoSocieta] = useState('Scegliere')
	const [NumeroCessioni, setNumeroCessioni] = useState(false)
	const [ElencoPrezziCessioni, setElencoPrezziCessioni] = useState(false)
	const [DescrizioneModifichePattiSociali, setDescrizioneModifichePattiSociali] = useState(false)
	const [DescrizioneOperazionePreventivo, setDescrizioneOperazionePreventivo] = useState(false)
	const [DescrizioneDelibereVerbalizzare, setDescrizioneDelibereVerbalizzare] = useState(false)

	const [ComposizionePatrimonioEreditario, setComposizionePatrimonioEreditario] = useState([])

	const [ImportoMutuo, setImportoMutuo] = useState(false)
	const [NomeBanca, setNomeBanca] = useState(false)
	const [ValoreIscrizioneIpotecaria, setValoreIscrizioneIpotecaria] = useState('Scegliere')

	const [TipoAttoCessioneAffAzienda, setTipoAttoCessioneAffAzienda] = useState(false)
	const [PrezzoVendita, setPrezzoVendita] = useState(false)
	const [CanoneAffitto, setCanoneAffitto] = useState(false)

	const [InfoPerPreventivo, setInfoPerPreventivo] = useState(false)

	const [ElencoPatrimonio, setElencoPatrimonio] = useState([])
	const [ElencoEredi, setElencoEredi] = useState([])

	const [ElencoBeni, setElencoBeni] = useState([])
	const [ValoreAppBeni, setValoreAppBeni] = useState(false)


	const [Nominativo, setNominativo] = useState(false)
	const [NaturaAtto, setNaturaAtto] = useState(false)
	const [NumeroRepertorio, setNumeroRepertorio] = useState(false)
	const [DataDiStipula, setDataDiStipula] = useState(false)
	const [NomeCognomeSoggettiAtto, setNomeCognomeSoggettiAtto] = useState(false)

	const [TipoRichiesta, setTipoRichiesta] = useState('Scegliere')

	const [PreferenzeGiorni, setPreferenzeGiorni] = useState(false)

	const [templateEmail, setTemplateEmail] = useState(false)

	const [Invia, setInvia] = useState(false)

	const [checked, setChecked] = useState(true);

	const [selectorQ, setSelectorQ] = useState(false);

	const handleChange = (event) => {
		setChecked(event.target.checked);
	};


	useEffect(
		() => {
			if (urlPage.includes('preventivo')) {
				setSubject(`Richiesta Preventivo`)
			}
			else if (urlPage.includes('informazioni')) {
				setSubject(`Richiesta Informazioni`)
			}
			else if (urlPage.includes('consulenza')) {
				setSubject(`Richiesta Consulenza`)
			}
			else if (urlPage.includes('copia-atti')) {
				setSubject(`Richiesta Copia Atto`)
			}
			else if (urlPage.includes('videoconferenza')) {
				setSubject(`Richiesta Videoconferenza`)
			}
		},
		[],
	);

	useEffect(() => {
		if (subject === 'Richiesta Preventivo') {
			const testoEmail = `
			<p><b>RICHIESTA DI PREVENTIVO</b></p>
			<p>Url di provenienza della richiesta:  ${urlHref}</p>
			<p>Nome: ${from_name}</p>
			<p>Cognome: ${from_surname}</p>
			<p>Indirizzo: ${indirizzo}</p>
			<p>Città: ${città}</p>
			<p>Email: ${from_mail}</p>
			<p>Telefono: ${phone}</p>
			<br></br>
			<p>TIPOLOGIA ATTO: <b>${tipoAtto}</b></p>
			`
			if (tipoAtto === 'Acquisto immobiliare') {
				const testoEmail_01 = `
				<p>Prezzo di acquisto: ${Prezzodiacquisto} </p>
				<p>Rendita catastale: ${RenditaCatastale} </p>
				<p>Chi è il venditore?: ${Venditore} </p>
				<p>Agevolazioni "Prima casa": ${AgevolazioniPrimaCasa} </p>
				<p>Verrà richiesto un mutuo?: ${RichiestaMutuo} </p>
				<br></br>
				<p><b>Informazioni aggiuntive</b></p>
				<p>${InfoAggiuntive}</p>
				`
				setTemplateEmail(testoEmail + testoEmail_01)
			}
			if (tipoAtto === 'Convenzione matrimoniale' | tipoAtto === 'Impresa familiare') {
				const testoEmail_01 = `
				<br></br>
				<p><b>Informazioni aggiuntive</b></p>
				<p>${InfoAggiuntive}</p>
				`
				setTemplateEmail(testoEmail + testoEmail_01)
			}

			if (tipoAtto === 'Successioni') {
				const testoEmail_01 = `
				<p>Come è composto il patrimonio ereditario ?: ${ComposizionePatrimonioEreditario}</p>
				<br></br>
				<p><b>Informazioni aggiuntive</b></p>
				<p>${InfoAggiuntive}</p>
				`
				setTemplateEmail(testoEmail + testoEmail_01)
			}

			if (tipoAtto === 'Atti societari') {
				if (TipoAttoSocieta === 'Atto costitutivo') {
					const testoEmail_01 = `
						<p>Tipologia società: ${TipoSocietà}</p>
						<p>Tipologia atto ${TipoSocietà}: ${TipoAttoSocieta}</p>
						<p>Ammontare del capitale sociale?: ${CapitaleSociale}</p>
						<br></br>
						<p><b>Informazioni aggiuntive</b></p>
						<p>${InfoAggiuntive}</p>
					`
					setTemplateEmail(testoEmail + testoEmail_01)
				}
				if (TipoAttoSocieta === 'Cessione di quote') {
					const testoEmail_01 = `
					<p>Tipologia società: ${TipoSocietà}</p>
					<p>Tipologia atto ${TipoSocietà}: ${TipoAttoSocieta}</p>
					<p>Indicare il numero di cessioni da effettuare: ${NumeroCessioni}</p>
					<p>Indicare il prezzo di ogni cessione: ${ElencoPrezziCessioni}</p>
					<br></br>
					<p><b>Informazioni aggiuntive</b></p>
					<p>${InfoAggiuntive}</p>
					`
					setTemplateEmail(testoEmail + testoEmail_01)
				}
				if (TipoAttoSocieta === 'Modifica dei patti sociali') {
					const testoEmail_01 = `
					<p>Tipologia società: ${TipoSocietà}</p>
					<p>Tipologia atto ${TipoSocietà}: ${TipoAttoSocieta}</p>
					<p>Descrivere sommariamente le modifiche da effettuare: ${DescrizioneModifichePattiSociali}</p>
					<br></br>
					<p><b>Informazioni aggiuntive</b></p>
					<p>${InfoAggiuntive}</p>
					`
					setTemplateEmail(testoEmail + testoEmail_01)
				}
				if (TipoAttoSocieta === 'Verbale di assemblea') {
					const testoEmail_01 = `
					<p>Tipologia società: ${TipoSocietà}</p>
					<p>Tipologia atto ${TipoSocietà}: ${TipoAttoSocieta}</p>
					<p>Descrivere sommariamente le delibere da verbalizzare: ${DescrizioneDelibereVerbalizzare}</p>
					<br></br>
					<p><b>Informazioni aggiuntive</b></p>
					<p>${InfoAggiuntive}</p>
					`
					setTemplateEmail(testoEmail + testoEmail_01)
				}
				if (TipoAttoSocieta === 'Altro') {
					const testoEmail_01 = `
					<p>Tipologia società: ${TipoSocietà}</p>
					<p>Tipologia atto ${TipoSocietà}: ${TipoAttoSocieta}</p>
					<p>Descrivere l'operazione per cui si richiede il preventivo *: ${DescrizioneOperazionePreventivo}</p>
					<br></br>
					<p><b>Informazioni aggiuntive</b></p>
					<p>${InfoAggiuntive}</p>
					`
					setTemplateEmail(testoEmail + testoEmail_01)
				}
			}
			if (tipoAtto === 'Mutuo') {
				const testoEmail_01 = `
				<p>Importo del mutuo richiesto ?: ${ImportoMutuo}</p>
				<p>Nome della banca ?: ${NomeBanca}</p>
				<p>Valore dell'iscrizione ipotecaria ?: ${ValoreIscrizioneIpotecaria}</p>
				<br></br>
				<p><b>Informazioni aggiuntive</b></p>
				<p>${InfoAggiuntive}</p>
				`
				setTemplateEmail(testoEmail + testoEmail_01)
			}
			if (tipoAtto === 'Cessione o affitto d’azienda') {
				if (TipoAttoCessioneAffAzienda === 'Cessione d’azienda') {
					const testoEmail_01 = `
					<p>Prezzo di vendita: ${PrezzoVendita}</p>
					<br></br>
					<p><b>Informazioni aggiuntive</b></p>
					<p>${InfoAggiuntive}</p>
					`
					setTemplateEmail(testoEmail + testoEmail_01)
				}
				if (TipoAttoCessioneAffAzienda === 'Affitto d’azienda') {
					const testoEmail_01 = `
					<p>Canone di affitto: ${CanoneAffitto}</p>
					<br></br>
					<p><b>Informazioni aggiuntive</b></p>
					<p>${InfoAggiuntive}</p>
					`
					setTemplateEmail(testoEmail + testoEmail_01)
				}

			}
			if (tipoAtto === 'Testamenti') {
				const testoEmail_01 = `
				<p>Patrimonio: ${ElencoPatrimonio}</p>
				<p>Eredi: ${ElencoEredi}</p>
				<br></br>
				<p><b>Informazioni aggiuntive</b></p>
				<p>${InfoAggiuntive}</p>
				`
				setTemplateEmail(testoEmail + testoEmail_01)
			}
			if (tipoAtto === 'Fondo patrimoniale/Trust') {
				const testoEmail_01 = `
				<p>Beni: ${ElencoBeni}</p>
				<p>Qual è il valore approssimativo dei beni da vincolare?: ${ValoreAppBeni}</p>
				<br></br>
				<p><b>Informazioni aggiuntive</b></p>
				<p>${InfoAggiuntive}</p>
				`
				setTemplateEmail(testoEmail + testoEmail_01)
			}
			if (tipoAtto === 'Altro') {
				const testoEmail_01 = `
				<p>Descrivere le operazioni per le quali si richiede il preventivo.: ${InfoPerPreventivo}</p>
				`
				setTemplateEmail(testoEmail + testoEmail_01)
			}
		}

		if (subject === 'Richiesta Copia Atto') {
			const testoEmail = `
			</p><b>RICHIESTA COPIA ATTO</b></p>
			</p>Url di provenienza della richiesta:  ${urlHref}</p>
			</p>Nome *: ${from_name} </p>
			</p>Cognome *: ${from_surname}</p>
			</p>Indirizzo: ${indirizzo}</p>
			</p>Città: ${città}</p>
			</p>Email *: ${from_mail}</p>
			</p>Telefono *: ${phone}</p>
			<br></br>
			<p>Nominativo: ${Nominativo}</p>
			<p>Data di stipula: ${DataDiStipula}</p>
			<p>Natura dell'Atto: ${NaturaAtto}</p>
			<p>Numero di repertorio: ${NumeroRepertorio}</p>
			<p>Nome o Cognome di uno o più soggetti dell'atto: ${NomeCognomeSoggettiAtto}</p>
			`
			setTemplateEmail(testoEmail)
		}

		if (subject === 'Richiesta Consulenza') {
			const testoEmail = `
			<p><b>RICHIESTA CONSULENZA</b></p>
			<p>Url di provenienza della richiesta:  ${urlHref}</p>
			<p>Nome *: ${from_name} </p>
			<p>Cognome *: ${from_surname}</p>
			<p>Indirizzo: ${indirizzo}</p>
			<p>Città: ${città}</p>
			<p>Email *: ${from_mail}</p>
			<p>Telefono *: ${phone}</p>
			<br></br>
			<p>Tipo di Richiesta: ${TipoRichiesta}</p>
			<p><b>Richiesta</b></p>
			<p>${message}</p>
			`
			setTemplateEmail(testoEmail)
		}

		if (subject === 'Richiesta Videoconferenza') {
			const testoEmail = `
			<p><b>RICHIESTA VIDEOCONFERENZA</b></p>
			<p>Url di provenienza della richiesta:  ${urlHref} </p>
			<p>Nome *: ${from_name} </p>
			<p>Cognome *: ${from_surname}</p>
			<p>Indirizzo: ${indirizzo}</p>
			<p>Città: ${città}</p>
			<p>Email *: ${from_mail}</p>
			<p>Telefono *: ${phone} </p>
			<p>Giorni e orari preferiti: ${PreferenzeGiorni}</p>
			<br></br>
			<p><b>Richiesta</b></p>
			<p>${message}</p>
			`
			setTemplateEmail(testoEmail)
		}

		if (subject === 'Richiesta Informazioni') {
			const testoEmail = `
			<p><b>RICHIESTA INFORMAZIONI</b></p>
			<p>Url di provenienza della richiesta:  ${urlHref} \n</p>
			<p>Nome *: ${from_name} </p>
			<p>Cognome *: ${from_surname}</p>
			<p>Indirizzo *: ${indirizzo}</p>
			<p>Città *: ${città}</p>
			<p>Email *: ${from_mail}</p>
			<p>Telefono *: ${phone}</p>
			<br></br>
			<p><b>Richiesta</b></p>
			<p>${message}</p>
			`
			setTemplateEmail(testoEmail)
		}

	});

	useEffect(() => {
		// 👇️ use a ref (best)
		// const el2 = ref.current;
		// console.log(el2);
	
		// 👇️ use document.querySelector()
		// should only be used when you can't set a ref prop on the element
		// (you don't have access to the element)
		setSelectorQ(ref.current)
		
	});


	function sendEmail(e) {
		e.preventDefault();

		if (from_name && from_surname && from_mail && phone) {
			if (!checked) {
				alert(`Prima di inviare la richiesta si prega di accettare l'informativa sulla privacy.\n\nStudio Notarile Falcinelli`)
			}
			else {
				console.log(selectorQ);
				emailjs.sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, selectorQ, process.env.REACT_APP_EMAILJS_USER_ID)
				// 	// emailjs.sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, e.target, process.env.REACT_APP_EMAILJS_USER_ID)

				.then((result) => {
					alert('Messaggio inviato. Grazie per aver contattato lo Studio Notarile Falcinelli!');
					window.location.reload();
				},

					(error) => {
						console.log(error.text);
					});
			}

		}

		else {
			alert('Attenzione si prega di compilare i campi obbligatori (nome, cognome, email, telefono, messaggio). Grazie!\n\nStudio Notarile Falcinelli');
		}
	}
	return (
		<div className="app_form">
			<p className='mt-3 text-center'>
				I campi contrassegnati con asterisco (*) sono obbligatori. Gli altri sono facoltativi.
			</p>
			<p className='text-center'>
				<strong>
					Lo Studio Notarile Falcinelli a Treviso è lieto di esaudire le vostre richieste e di venire incontro alle vostre esigenze per questo non esistate a contattarci.
				</strong>
			</p>

			<form onSubmit={sendEmail} id="form">
				<InfoIniziali
					setFrom_name={setFrom_name}
					setFrom_surname={setFrom_surname}
					setIndirizzo={setIndirizzo}
					setCittà={setCittà}
					setFrom_mail={setFrom_mail}
					setPhone={setPhone}
					subject={subject}
				/>

				{(() => {

					if (subject === 'Richiesta Preventivo') {
						return (
							<>
								<Preventivo
									tipoAtto={tipoAtto}
									setTipoAtto={setTipoAtto}
									setPrezzodiacquisto={setPrezzodiacquisto}
									setAgevolazioniPrimaCasa={setAgevolazioniPrimaCasa}
									setRichiestaMutuo={setRichiestaMutuo}
									setInfoAggiuntive={setInfoAggiuntive}
									setVenditore={setVenditore}
									setRenditaCatastale={setRenditaCatastale}
									TipoSocietà={TipoSocietà}
									setTipoSocietà={setTipoSocietà}
									setCapitaleSociale={setCapitaleSociale}
									TipoAttoSocieta={TipoAttoSocieta}
									setTipoAttoSocieta={setTipoAttoSocieta}
									setNumeroCessioni={setNumeroCessioni}
									setElencoPrezziCessioni={setElencoPrezziCessioni}
									setDescrizioneModifichePattiSociali={setDescrizioneModifichePattiSociali}
									setDescrizioneOperazionePreventivo={setDescrizioneOperazionePreventivo}
									setDescrizioneDelibereVerbalizzare={setDescrizioneDelibereVerbalizzare}
									ComposizionePatrimonioEreditario={ComposizionePatrimonioEreditario}
									setComposizionePatrimonioEreditario={setComposizionePatrimonioEreditario}
									setImportoMutuo={setImportoMutuo}
									setNomeBanca={setNomeBanca}
									setValoreIscrizioneIpotecaria={setValoreIscrizioneIpotecaria}
									TipoAttoCessioneAffAzienda={TipoAttoCessioneAffAzienda}
									setTipoAttoCessioneAffAzienda={setTipoAttoCessioneAffAzienda}
									setPrezzoVendita={setPrezzoVendita}
									setCanoneAffitto={setCanoneAffitto}
									setInfoPerPreventivo={setInfoPerPreventivo}
									ElencoPatrimonio={ElencoPatrimonio}
									setElencoPatrimonio={setElencoPatrimonio}
									ElencoEredi={ElencoEredi}
									setElencoEredi={setElencoEredi}
									ElencoBeni={ElencoBeni}
									setElencoBeni={setElencoBeni}
									setValoreAppBeni={setValoreAppBeni}
								/>
							</>
						);
					}

					if (subject === 'Richiesta Copia Atto') {
						return (
							<>
								<CopiaAtto
									setNominativo={setNominativo}
									setNaturaAtto={setNaturaAtto}
									setNumeroRepertorio={setNumeroRepertorio}
									setDataDiStipula={setDataDiStipula}
									setNomeCognomeSoggettiAtto={setNomeCognomeSoggettiAtto}
								/>
							</>
						);
					}

					if (subject === 'Richiesta Consulenza') {
						return (
							<>
								<Consulenza
									setTipoRichiesta={setTipoRichiesta}
									setMessage={setMessage}
								/>
							</>
						);
					}

					if (subject === 'Richiesta Videoconferenza') {
						return (
							<>
								<Videoconferenza
									setMessage={setMessage}
									setPreferenzeGiorni={setPreferenzeGiorni}
								/>
							</>
						);
					}

					if (subject === 'Richiesta Informazioni') {
						return (
							<Informazioni
								setMessage={setMessage}
							/>
						);
					}

				})()}

				<MDBRow>
					<InformativaPrivacy
						checked={checked}
						handleChange={handleChange} />
				</MDBRow>
				<MDBRow className='text-center'>
					<MDBCol>
						<button
							className="button button-a button-big button-rouded"
							type="submit"
							value="Invia"
							id="button"
							onClick={() => setInvia(true)}
						>
							Invia
						</button>
					</MDBCol>
				</MDBRow>
			</form >
			<form style={{display:'none'}} ref={ref} id="FinalForm">
				<input type="text" value={from_name} name="UserName" id="UserName"/>
				<input type="text" value={from_surname} name="UserSurname" id="UserSurname" />
				<input type="mail" value={from_mail} name="UserMail" id="UserMail"/>
				<input type="text" value={urlHref} name="UrlSite" id="UrlSite"/>
				<textarea type="textarea" value={templateEmail} name="CorpusText" id="CorpusText"/>
			</form>
		</div>
	);
}

